import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appKeepVerticalScroll]',
})
export class KeepVerticalScrollDirective {
  constructor(private el: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    const top = event.path[1].pageYOffset;
    this.el.nativeElement.setAttribute('style', `top:${top}px`);
  }
}
